window.AAAdminWorkspaceView = (() => {
  const PARAM = 'aa_admin_client';

  let authorizedClientId = null;

  function getRequestedClientId() {
    const params = new URLSearchParams(window.location.search);

    return params.get(PARAM)?.trim() || null;
  }

  async function getAuthorizedClientId() {
    const requestedClientId = getRequestedClientId();

    if (!requestedClientId) {
      authorizedClientId = null;
      return null;
    }

    if (!window.AAWorkspaceContext?.getWorkspaceAuthContext) {
      return null;
    }

    const auth =
      await window.AAWorkspaceContext.getWorkspaceAuthContext();

   if (
  !auth?.user ||
  auth?.locked ||
  auth?.isInternal !== true
) {
  authorizedClientId = null;
  return null;
}

authorizedClientId = requestedClientId;

/*
 * Admin View only:
 * Keep the existing workspace fallback aligned with the
 * client Headquarters explicitly authorized for this view.
 *
 * This prevents a legacy AA_CLIENT_ID value from replacing
 * the authorized Admin View client during later initialization.
 */
window.AA_CLIENT_ID = authorizedClientId;

return authorizedClientId;
  }

  function preserveAdminClientInLinks() {
    if (!authorizedClientId) return;

    document
      .querySelectorAll('.aa-workspace a[href^="/pages/workspace-"]')
      .forEach((link) => {
        const url = new URL(link.href, window.location.origin);

        url.searchParams.set(PARAM, authorizedClientId);

        link.href =
          `${url.pathname}${url.search}${url.hash}`;
      });
  }

  function watchModuleNavigation() {
    const mount =
      document.querySelector('[data-aa-client-module-nav]');

    if (!mount || !authorizedClientId) return;

    const observer = new MutationObserver(() => {
      preserveAdminClientInLinks();
    });

    observer.observe(mount, {
      childList: true,
      subtree: true
    });
  }

  function enhanceWorkspace() {
    if (!authorizedClientId) return;

    preserveAdminClientInLinks();
    watchModuleNavigation();
  }

  function getClientId() {
    return authorizedClientId;
  }

  return {
    getAuthorizedClientId,
    enhanceWorkspace,
    getClientId
  };
})();